import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum ImmunizationStatusEnum {
    "Completed" = 1,
    "Pending - Not Administered" = 2,
    "Declined" = 3
}

export class ImmunizationStatusClass extends EnumWithDescription<ImmunizationStatusEnum> {
    public readonly enum = ImmunizationStatusEnum;
    public readonly enumName: string = "ImmunizationStatusEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<ImmunizationStatusEnum>> = new Map([
        [
            "Completed",
            {
                name: "Completed",
                value: 1
            }
        ],
        [
            "Pending - Not Administered",
            {
                name: "Pending - Not Administered",
                value: 2
            }
        ],
        [
            "Declined",
            {
                name: "Declined",
                value: 3
            }
        ]
    ]);
}

export const ImmunizationStatus = new ImmunizationStatusClass();
